<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style src="./assets/css/kcalmar_design.css"></style>
<style>
html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type="button"],[type="reset"],[type="submit"]{-webkit-appearance:button}button::-moz-focus-inner,[type="button"]::-moz-focus-inner,[type="reset"]::-moz-focus-inner,[type="submit"]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type="button"]:-moz-focusring,[type="reset"]:-moz-focusring,[type="submit"]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type="checkbox"],[type="radio"]{box-sizing:border-box;padding:0}[type="number"]::-webkit-inner-spin-button,[type="number"]::-webkit-outer-spin-button{height:auto}[type="search"]{-webkit-appearance:textfield;outline-offset:-2px}[type="search"]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}

@font-face {
  font-family: 'Roboto-Light';
  src: url('./assets/font/Roboto-Light.ttf') format("truetype");
}
@font-face {
  font-family: 'Roboto-Medium';
  src: url('./assets/font/Roboto-Medium.ttf') format("truetype");
}
@font-face {
  font-family: 'Roboto-Regular';
  src: url('./assets/font/Roboto-Regular.ttf') format("truetype");
}
/* TODO CR przenieść do globalnych styli lub wywalić gdy będzie materialize*/
html, body{
  width: 100%;
  height: 100%;
}
html{
  font-family: 'Roboto-Light', sans-serif;
}
body{
  font-size: 15px;
}
a{
  text-decoration: none;
}
p{
  margin: 5px;
}
h1{
  /* height: 54px; */
  /* width: 141px; */
  color: #000000;
  font-size: 38px;
  font-weight: 300;
  line-height: 54px;
}
h2{
  color: #000000;
  font-size: 28px;
  font-weight: 300;
  margin-bottom: 25px;
  margin-top: 50px;

}
select{
  outline: none;
  width: 100%;
  background: transparent;
  border: 0px;
  border-bottom: 2px solid #999;
  padding: 10px 7px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(assets/img/common/grey_down_arrow.svg);
  background-position: right center;
  background-size: 17px;
  background-repeat: no-repeat;
  cursor: pointer;
}
#app{
  height: 100%
}
.flex-grow{
  flex-grow: 1;
}
.price-with-out-discount-label{
  font-family: 'Roboto-Regular';
  font-weight: 700;
  color: #a7a7a7;
  font-size: 10px;
  height: 20px;
}
.price-with-out-discount-label span{
  font-size: 18px;
  text-decoration: line-through;
}
.row{
  display: flex;
  flex-wrap: wrap;
}
.star--vip{
  height: 17px;
  width: 17px;
  background-image: url(assets/img/common/star.svg);
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
}
.hide{
  display: none;
}
</style>
